import {
  resolveVacationPackageIncludedBaggage,
  resolveVacationPackageIncludedBaggageForLeg,
} from "./resolveVacationPackageIncludedBaggage";
import { isDealTransferIncluded } from "./isDealTransferIncluded";

/** תווית כבודה לכיוון בודד — כמו VacationPackagesFlightDetails */
function formatLegBaggageLabelHe(b) {
  if (!b) return null;
  const parts = [];
  if (b.carryOnIncluded) {
    parts.push(
      b.carryOnWeightKg != null
        ? `תיק יד ${b.carryOnWeightKg} ק"ג`
        : "תיק יד כלול"
    );
  }
  if (b.checkedBaggageIncluded) {
    parts.push(
      b.checkedBaggageWeightKg != null
        ? `מזוודה ${b.checkedBaggageWeightKg} ק"ג`
        : "מזוודה כלולה"
    );
  }
  return parts.length > 0 ? parts.join(" · ") : null;
}

/** שורות כבודה כלולה ברמת חבילה — כמו sidebar (טרולי + מזוודה) */
function formatPackageIncludedBaggageLines(baggageResolved) {
  if (!baggageResolved?.hasAnyIncluded) return [];

  const lines = [];
  if (baggageResolved.carryOnIncluded) {
    lines.push(
      baggageResolved.carryOnWeightKg != null
        ? `טרולי ${baggageResolved.carryOnWeightKg} ק"ג`
        : "טרולי כלול"
    );
  }
  if (baggageResolved.checkedBaggageIncluded) {
    lines.push(
      baggageResolved.checkedBaggageWeight != null
        ? `מזוודה ${baggageResolved.checkedBaggageWeight} ק"ג`
        : "מזוודה כלולה"
    );
  }

  if (lines.length === 0 && baggageResolved.summaryLabel) {
    const stripped = String(baggageResolved.summaryLabel)
      .replace(/^כולל\s+/i, "")
      .trim();
    if (stripped && !/ללא כבודה/i.test(stripped)) {
      lines.push(stripped);
    }
  }

  return lines;
}

/**
 * כלול בחבילה ל-PDF (העברות + כבודה מטיסות) — אותו SSOT כמו פרופיל/sidebar.
 * @param {{ selectedResult?: object|null }} input
 */
export function buildVpPdfPackageInclusions(input = {}) {
  const selectedResult = input.selectedResult ?? null;
  const transferIncluded = isDealTransferIncluded(selectedResult);
  const baggageResolved = resolveVacationPackageIncludedBaggage(selectedResult);
  const baggageLines = formatPackageIncludedBaggageLines(baggageResolved);
  const baggageIncluded = baggageLines.length > 0;

  return {
    showSection: transferIncluded || baggageIncluded,
    transferIncluded,
    transferLabel: "כולל העברות (משדה התעופה למלון ובחזרה)",
    baggageIncluded,
    baggageLines,
    baggageNote: baggageIncluded ? "כבודה כלולה בטיסה/חבילה" : null,
    baggageSummaryText: baggageLines.length > 0 ? baggageLines.join(" + ") : null,
  };
}

/**
 * כבודה לכרטיס טיסה ב-PDF.
 * @param {object|null|undefined} leg
 * @param {object|null|undefined} flightWrapper
 */
export function resolveVpPdfFlightBaggageLabel(leg, flightWrapper = null) {
  if (!leg) return null;
  return formatLegBaggageLabelHe(
    resolveVacationPackageIncludedBaggageForLeg(leg, flightWrapper)
  );
}
